import React from 'react';
import { makeStyles } from '@material-ui/styles';
import ReactPlayer from 'react-player';
import { Zoom, Fab } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
const useStyles = makeStyles(({ spacing }) => ({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
  },
  fab: {
    position: 'absolute',
    top: spacing(2),
    right: spacing(2)
  }
}));

const VideoPlayer = ({ open, height, url, onClose }) => {
  const classes = useStyles({})
;
  return (
    <Zoom in={open}>
      <div className={classes.root}>
        <Fab aria-label="Close Player" className={classes.fab} onClick={onClose} size="small">
          <CloseIcon />
        </Fab>
        <ReactPlayer playing={open} height={height} width="100%" playsinline url={url} />
      </div>
    </Zoom>
  );
};

export default VideoPlayer;
